import { RoundedFilledButton } from '@/components/buttons/Buttons';
import styles from './template.module.css';

type Props = {
	onDismiss?: () => void;
	onProceed?: () => void;
};

const DeclinedByBankTemplate = (props: Props) => {
	const { onDismiss, onProceed } = props;
	return (
		<>
			<h2 className={styles.errorTitle}>Declined by bank</h2>
			<p className="mb-6">
				Please try another payment method or check with your bank.
			</p>
			<RoundedFilledButton
				id="switch-payment-method"
				label="Switch Payment Method"
				className={styles.roundedButton}
				onClick={onProceed}
			/>
			<RoundedFilledButton
				id="dismiss"
				label="Dismiss"
				className={styles.dismissButton}
				onClick={onDismiss}
			/>
		</>
	);
};

export default DeclinedByBankTemplate;
